import { withStyles } from '@material-ui/core/styles';
import { TableCell, TablePagination } from '@material-ui/core';

const StyledTableCell = withStyles(() => ({
  root: {
    border: 'none',
    padding: 6,
    fontSize: '1rem',
    whiteSpace: 'nowrap'
  },
}))(TableCell);
const StyledTableCellCollapse = withStyles(() => ({
  root: {
    border: 'none',
    padding: 6,
    fontSize: '1rem',
  },
}))(TableCell);
const StyledTableHeadCellLeads = withStyles(() => ({
  root: {
    border: 'none',
    padding: 6,
    fontSize: '1rem',
    backgroundColor: '#f2f5f7',
  },
}))(TableCell);
const StyledContentTableCell = withStyles(() => ({
  root: {
    border: 'none',
    padding: 6,
    fontSize: '1rem',
  },
}))(TableCell);
const StyledContentTableHeadCell = withStyles(() => ({
  head: {
    border: 'none',
    backgroundColor: '#E5E5E5',
    color: '#101010',
    padding: 6,
    fontSize: '1rem',
  },
}))(TableCell);
const StyledContentTableHeadCell1 = withStyles(() => ({
  head: {
    border: 'none',
    borderRadius: '4px 0 0 4px',
    backgroundColor: '#E5E5E5',
    color: '#101010',
    padding: 6,
    fontSize: '1rem',
  },
}))(TableCell);
const StyledContentTableHeadCell2 = withStyles(() => ({
  head: {
    border: 'none',
    borderRadius: '0 4px 4px 0',
    backgroundColor: '#E5E5E5',
    color: '#101010',
    padding: 6,
    fontSize: '1rem',
  },
}))(TableCell);
const StyledTableHeadCell = withStyles(() => ({
  head: {
    border: 'none',
    backgroundColor: '#E5E5E5',
    color: '#101010',
    fontSize: '1rem',
    padding: 6,
  },
}))(TableCell);
const StyledTableHeadCell1 = withStyles(() => ({
  head: {
    border: 'none',
    borderRadius: '4px 0 0 4px',
    backgroundColor: '#E5E5E5',
    color: '#101010',
    fontSize: '1rem',
    padding: 6,
  },
}))(TableCell);
const StyledTableHeadCell2 = withStyles(() => ({
  head: {
    border: 'none',
    borderRadius: '0 4px 4px 0',
    backgroundColor: '#E5E5E5',
    color: '#101010',
    fontSize: '1rem',
    padding: 6,
  },
}))(TableCell);
const StyledTableCellGmb = withStyles(() => ({
  root: {
    border: 'none',
    padding: 6,
    textAlign: 'center',
    '&:first-child': {
      textAlign: 'left',
    },
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
}))(TableCell);
const StyledTableHeadCellGmb = withStyles(() => ({
  head: {
    border: 'none',
    backgroundColor: '#E5E5E5',
    color: '#101010',
    fontSize: 14,
    padding: 6,
    textAlign: 'center',
    '&:first-child': {
      textAlign: 'left',
    },
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
}))(TableCell);
const StyledTablePagination = withStyles(() => ({
  root: {
    fontSize: '14px',
  },
  caption: {
    fontSize: '14px',
  },
  actions: {
    Button: {
      fontSize: '14px',
    },
  },
}))(TablePagination);
export {
  StyledTableCell,
  StyledTableCellCollapse,
  StyledTableHeadCell,
  StyledTableHeadCell1,
  StyledTableHeadCell2,
  StyledTablePagination,
  StyledContentTableCell,
  StyledContentTableHeadCell,
  StyledContentTableHeadCell1,
  StyledContentTableHeadCell2,
  StyledTableCellGmb,
  StyledTableHeadCellGmb,
  StyledTableHeadCellLeads,
};
